import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { XCircle, ArrowLeft, CreditCard, HelpCircle } from 'lucide-react';

export default function SubscriptionCancel() {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-gray-100 p-4">
      <Card className="w-full max-w-lg">
        <CardContent className="pt-8 pb-8 text-center">
          {/* Cancel Icon */}
          <div className="w-16 h-16 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle className="h-8 w-8 text-slate-500" />
          </div>
          
          {/* Message */}
          <h1 className="text-2xl font-bold text-slate-900 mb-2">
            Payment Cancelled
          </h1>
          <p className="text-slate-600 mb-6">
            Your payment was cancelled and you haven't been charged. 
            Your free trial continues until it expires.
          </p>
          
          {/* Info Box */}
          <div className="bg-blue-50 rounded-lg p-4 mb-6 text-left">
            <div className="flex gap-3">
              <HelpCircle className="h-5 w-5 text-blue-600 flex-shrink-0 mt-0.5" />
              <div>
                <h3 className="font-medium text-blue-900 mb-1">Need help deciding?</h3>
                <p className="text-sm text-blue-800">
                  Not sure which plan is right for you? Contact us and we'll help you 
                  choose the best option for your business.
                </p>
              </div>
            </div>
          </div>
          
          {/* Actions */}
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button 
              variant="outline" 
              onClick={() => navigate('/dashboard')}
              className="order-2 sm:order-1"
            >
              <ArrowLeft className="h-4 w-4 mr-2" />
              Back to Dashboard
            </Button>
            <Button 
              onClick={() => navigate('/subscription')}
              className="bg-blue-600 hover:bg-blue-700 order-1 sm:order-2"
            >
              <CreditCard className="h-4 w-4 mr-2" />
              View Plans
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
